import { Box, Button, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import styled from "styled-components";
import EmployeeActions from "./EmployeeActions";
import ModalBox from "../ModalBox";
import HourlyRateActions from "./HourlyRateActions";
import SendTwoToneIcon from "@mui/icons-material/SendTwoTone";
import PaidStatusAction from "./PaidStatusAction";
import { useNavigate } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

const ButtonWrapper = styled.div`
  width: 200px;
  margin: 10px auto;

  button {
    margin: 0 10px;
    color: white;
    font-size: 11px;
  }
`;
const SingleButtonWrapper = styled.div`
  margin: 10px auto;

  button {
    margin: 0 10px;
    color: white;
    font-size: 11px;
  }
`;

function Actions({
  editing,
  setEditing,
  id,
  actions,
  data,
  row,
  col,
  roleId,
  setRoleId,
  Discarding,
  setDiscarding,
  cid,
  inSiteDetails,
}) {
  const [open, setOpen] = useState(false);
  const [openSend, setOpenSend] = useState(false);
  const [openPayrollModal, setOpenPayrollModal] = useState(false);
  const navigate = useNavigate();

  let theme = useTheme();
  const handleClose = () => {
    setOpen(false);
  };

  const handleEdit = (row) => {
    editing &&
      actions.edit(
        data.filter((e) => e.id === id || e.roleId === id || e.siteId === id),
        id,
      );
    editing && setEditing(null);
  };
  const handleDelete = (id, row) => {
    editing && setEditing(false);
    !editing && setOpen(true);
  };
  if (actions.PaidStatus) {
    return <PaidStatusAction row={row} actions={actions} />;
  }
  if (actions.emoloyee) {
    return (
      <EmployeeActions
        editing={editing}
        setEditing={setEditing}
        id={id}
        actions={actions}
        data={data}
        row={row}
      ></EmployeeActions>
    );
  }
  if (actions.hourlyRate) {
    return (
      <HourlyRateActions
        data={data}
        row={row}
        id={id}
        companyId={cid}
        actions={actions}
        editing={editing}
        setEditing={setEditing}
        roleId={roleId}
        setRoleId={setRoleId}
        col={col}
        Discarding={Discarding}
        setDiscarding={setDiscarding}
        inSiteDetails={inSiteDetails}
      />
    );
  }
  if (editing === id) {
    return (
      <ButtonWrapper>
        {actions.edit && (
          <Button
            onClick={() => {
              handleEdit(id);
            }}
            style={{
              backgroundColor: "black",
              "&:hover": { background: `${theme.color.black}` },
            }}
            disabled={actions.vState}
          >
            Save
          </Button>
        )}
        {actions.delete && (
          <Button
            onClick={() => {
              setEditing(null);
            }}
            style={{
              background: theme.color.gray200,
              color: "black",
              "&:hover": { background: `${theme.color.gray200}` },
            }}
          >
            Discard
          </Button>
        )}
      </ButtonWrapper>
    );
  }
  if (actions.close || actions.paid)
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <SingleButtonWrapper>
          {actions.close && (
            <Box>
              <Button
                onClick={() => {
                  setOpenPayrollModal(true);
                }}
                disabled={
                  row.status === "Closed" || row.status === "Archive"
                    ? true
                    : false
                }
                sx={{
                  background: "#FF4747",
                  "&:hover": {
                    background: `${theme.color.redHoverBackground}`,
                  },
                  "&.Mui-disabled": {
                    backgroundColor: `${theme.color.grayBackground}`,
                    color: `${theme.color.dark}`,
                  },
                }}
              >
                {row.status === "Closed"
                  ? "Saved"
                  : row.status === "Archive"
                    ? "Archived"
                    : "Saved"}
              </Button>
            </Box>
          )}
          {actions.paid &&
            (row.status === "Open" ? (
              <Typography variant="Poster" component="h5">
                Close payroll to pay salary
              </Typography>
            ) : (
              <Button
                onClick={() => {
                  setOpenPayrollModal(true);
                }}
                disabled={!!row.paidDate}
                sx={{
                  background: "#FF4747",
                  "&:hover": {
                    background: `${theme.color.redHoverBackground}`,
                  },
                  "&.Mui-disabled": {
                    backgroundColor: `${theme.color.grayBackground}`,
                    color: `${theme.color.dark}`,
                  },
                }}
              >
                {row.paidDate === null ? "Pay Salary" : "Paid"}
              </Button>
            ))}
        </SingleButtonWrapper>
        <ModalBox
          open={openPayrollModal}
          operation={actions.paid ? "pay" : "delete"}
          handleClose={() => {
            actions.setInTableRender(!actions.InTableRender);
            setOpenPayrollModal(false);
          }}
          handleOperation={() => {
            if (actions.paid) actions.paid(id);
            if (actions.close) {
              actions.close(id, cid);
            }
          }}
          text={
            actions.paid
              ? `Are you sure you want to pay the salary of this employee?`
              : `Are you sure you want to complete the process of closing this payroll?`
          }
          btnLabel={actions.paid && "Pay Salary"}
        />
      </Box>
    );

  return (
    <>
      <ButtonWrapper>
        {actions.edit && (
          <Button
            onClick={() => {
              actions.inTableEdit ? setEditing(id || 0) : actions.edit(id, row);
            }}
            style={{
              backgroundColor: "#FFC555",
              "&:hover": { background: `${theme.color.black}` },
              width: !actions.delete && "150px",
            }}
          >
            Edit
          </Button>
        )}
        {actions.delete && (
          <Button
            onClick={() => {
              handleDelete(id, row);
            }}
            style={{
              background: "#FF4747",
              width: !actions.edit && "150px",
              "&:hover": { background: `${theme.color.redHoverBackground}` },
            }}
          >
            Delete
          </Button>
        )}
        {actions.reSend &&
          (row.statusId !== 3 ? (
            <Button
              onClick={() => {
                setOpenSend(true);
              }}
              style={{
                backgroundColor: "#FFC555",
                "&:hover": { background: `${theme.color.black}` },
                width: "150px",
              }}
            >
              Send
              <SendTwoToneIcon fontSize="small" sx={{ m: "2px" }} />
            </Button>
          ) : (
            <Button
              disabled
              style={{
                background: "#b1edab",
                color: "#13430E",
                width: "150px",
                opacity: 0.7,
              }}
            >
              Sent
            </Button>
          ))}

        <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
          {actions.odooInvoicesReportAction && (
            <Button
              onClick={() => {
              actions.odooInvoicesReportAction(row);
              }}
              size="small"
              style={{
                textTransform: "capitalize",
                color: "white",
                marginInline: "20px",
                backgroundColor: "black",
                "&:hover": { background: `${theme.color.black}` },
              }}
            >
              Send All
            </Button>
          )}
          {actions.showMoreInvoices && (
            <Box
              onClick={() => {
                navigate("/Odoo/OdooInvoices");
                actions.showMoreInvoices(row);
              }}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "4px",
                cursor: "pointer",
                color: "rgba(0, 0, 0, 0.6)",
                borderRadius: "6px",
                padding: "4px 8px",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  color: "black",
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              <span style={{ fontSize: "13px" }}> Details</span>
              <MoreHorizIcon fontSize="small" />
            </Box>
          )}
        </Box>
      </ButtonWrapper>
      <ModalBox
        open={open}
        operation="delete"
        handleClose={handleClose}
        handleOperation={() => {
          actions.delete(id, row);
          setOpen(false);
        }}
        text={`Do you want to complete the process of deleting all information?`}
      />
      <ModalBox
        open={openSend}
        operation="send"
        handleClose={handleClose}
        handleOperation={() => {
          if (row?.siteTransactionId) actions.reSend(row?.siteTransactionId);
          else actions.reSend(row?.siteShiftId);
          setOpenSend(false);
        }}
        text={`Do you want to send ?`}
      />
    </>
  );
}

export default Actions;
